import axios from 'axios'
import { apiBaseURL, mallBaseURL } from '../../_base'

export default {
  getTeacherInfo: (data, config = {}) =>
    axios.post(`${mallBaseURL}Creator/Header/getHeaderInfo`, data, config),
  getCourseInfos: (data, config = {}) =>
    axios.post(`${apiBaseURL}galaxyapi/Creator/Course/getCourseList`, data, config)
}



// WEBPACK FOOTER //
// ./src/networks/api/Teacher/index.js